var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"no-border"},[_c('div',{staticClass:"ql-snow"},[_c('div',{staticClass:"ql-editor"},[_c('vue-editor',{staticStyle:{"display":"none"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }